import { Injectable } from '@angular/core';
import { gql } from '@apollo/client/core';
import { Mutation } from 'apollo-angular';

import { AddToMyCartResponse } from '../models/add-to-cart.response';
import { AddToMyCartVariables } from '../models/add-to-cart.variables';

@Injectable({
  providedIn: 'root',
})
export class AddToMyCartMutation extends Mutation<AddToMyCartResponse, AddToMyCartVariables> {
  override document = gql`
    mutation (
      $sku: String!
      $exportCatalogSku: String!
      $locale: NonEmptyString
      $quantity: Int!
      $tintedProduct: TintedProductInput
      $customColorInformation: CustomColorInformationInput
    ) {
      addLineItemToMyCart(
        lineItemInputs: {
          sku: $sku
          exportCatalogSku: $exportCatalogSku
          quantity: $quantity
          tintedProduct: $tintedProduct
          customColorInformation: $customColorInformation
        }
        locale: $locale
      ) {
        lineItems {
          quantity
          sku
          exportCatalogSku
          externalPrice {
            amount
            centAmount
            currencyCode
          }
          externalTotalPrice {
            amount
            centAmount
            currencyCode
          }
          externalPriceBeforeDiscount {
            amount
            centAmount
            currencyCode
          }
          externalTotalPriceBeforeDiscount {
            amount
            centAmount
            currencyCode
          }
          totalPromotionDiscountAmount {
            amount
            centAmount
            currencyCode
          }
          tintedProduct {
            colorName
            colorCode
            hexColorCode
            paletteName
            paletteCode
          }
          customColorInformation {
            configurableMaterialSku
            tintBase
          }
        }
      }
    }
  `;
}
